module.exports = __webpack_public_path__ + "static/media/icon_lotion.542aff68.svg";